// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file shopify/v1/carrier_service.proto (package shopify.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Extensions, PageInfo, UserError } from './graphql_pb';
import { file_shopify_v1_graphql } from './graphql_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file shopify/v1/carrier_service.proto.
 */
export const file_shopify_v1_carrier_service: GenFile =
    /*@__PURE__*/
    fileDesc(
        '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',
        [file_shopify_v1_graphql]
    );

/**
 * @generated from message shopify.v1.CarrierServiceListRequest
 */
export type CarrierServiceListRequest = Message<'shopify.v1.CarrierServiceListRequest'> & {
    /**
     * @generated from field: int32 first = 1;
     */
    first: number;

    /**
     * @generated from field: string query = 2;
     */
    query: string;
};

/**
 * Describes the message shopify.v1.CarrierServiceListRequest.
 * Use `create(CarrierServiceListRequestSchema)` to create a new message.
 */
export const CarrierServiceListRequestSchema: GenMessage<CarrierServiceListRequest> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 0);

/**
 * @generated from message shopify.v1.CarrierServiceResponse
 */
export type CarrierServiceResponse = Message<'shopify.v1.CarrierServiceResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceQueryResponse data = 1;
     */
    data?: CarrierServiceQueryResponse | undefined;

    /**
     * @generated from field: shopify.v1.Extensions extensions = 2;
     */
    extensions?: Extensions | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError errors = 3;
     */
    errors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceResponse.
 * Use `create(CarrierServiceResponseSchema)` to create a new message.
 */
export const CarrierServiceResponseSchema: GenMessage<CarrierServiceResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 1);

/**
 * @generated from message shopify.v1.CarrierServiceQueryResponse
 */
export type CarrierServiceQueryResponse = Message<'shopify.v1.CarrierServiceQueryResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceConnection carrier_services = 1;
     */
    carrierServices?: CarrierServiceConnection | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceQueryResponse.
 * Use `create(CarrierServiceQueryResponseSchema)` to create a new message.
 */
export const CarrierServiceQueryResponseSchema: GenMessage<CarrierServiceQueryResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 2);

/**
 * @generated from message shopify.v1.CarrierServiceConnection
 */
export type CarrierServiceConnection = Message<'shopify.v1.CarrierServiceConnection'> & {
    /**
     * @generated from field: optional shopify.v1.PageInfo page_info = 1;
     */
    pageInfo?: PageInfo | undefined;

    /**
     * @generated from field: repeated shopify.v1.CarrierServiceEdge edges = 2;
     */
    edges: CarrierServiceEdge[];
};

/**
 * Describes the message shopify.v1.CarrierServiceConnection.
 * Use `create(CarrierServiceConnectionSchema)` to create a new message.
 */
export const CarrierServiceConnectionSchema: GenMessage<CarrierServiceConnection> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 3);

/**
 * @generated from message shopify.v1.CarrierServiceEdge
 */
export type CarrierServiceEdge = Message<'shopify.v1.CarrierServiceEdge'> & {
    /**
     * @generated from field: shopify.v1.CarrierService node = 1;
     */
    node?: CarrierService | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceEdge.
 * Use `create(CarrierServiceEdgeSchema)` to create a new message.
 */
export const CarrierServiceEdgeSchema: GenMessage<CarrierServiceEdge> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 4);

/**
 * @generated from message shopify.v1.CarrierService
 */
export type CarrierService = Message<'shopify.v1.CarrierService'> & {
    /**
     * @generated from field: string id = 1;
     */
    id: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string callback_url = 3;
     */
    callbackUrl: string;

    /**
     * @generated from field: bool active = 4;
     */
    active: boolean;

    /**
     * @generated from field: bool supports_service_discovery = 5;
     */
    supportsServiceDiscovery: boolean;
};

/**
 * Describes the message shopify.v1.CarrierService.
 * Use `create(CarrierServiceSchema)` to create a new message.
 */
export const CarrierServiceSchema: GenMessage<CarrierService> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 5);

/**
 * @generated from message shopify.v1.CarrierServiceDeleteRequest
 */
export type CarrierServiceDeleteRequest = Message<'shopify.v1.CarrierServiceDeleteRequest'> & {
    /**
     * @generated from field: string id = 1;
     */
    id: string;
};

/**
 * Describes the message shopify.v1.CarrierServiceDeleteRequest.
 * Use `create(CarrierServiceDeleteRequestSchema)` to create a new message.
 */
export const CarrierServiceDeleteRequestSchema: GenMessage<CarrierServiceDeleteRequest> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 6);

/**
 * @generated from message shopify.v1.CarrierServiceDeleteResponse
 */
export type CarrierServiceDeleteResponse = Message<'shopify.v1.CarrierServiceDeleteResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceDeleteMutationResponse data = 1;
     */
    data?: CarrierServiceDeleteMutationResponse | undefined;

    /**
     * @generated from field: shopify.v1.Extensions extensions = 2;
     */
    extensions?: Extensions | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError errors = 3;
     */
    errors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceDeleteResponse.
 * Use `create(CarrierServiceDeleteResponseSchema)` to create a new message.
 */
export const CarrierServiceDeleteResponseSchema: GenMessage<CarrierServiceDeleteResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 7);

/**
 * @generated from message shopify.v1.CarrierServiceDeleteMutationResponse
 */
export type CarrierServiceDeleteMutationResponse = Message<'shopify.v1.CarrierServiceDeleteMutationResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceDeletePayload carrier_service_delete = 1;
     */
    carrierServiceDelete?: CarrierServiceDeletePayload | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceDeleteMutationResponse.
 * Use `create(CarrierServiceDeleteMutationResponseSchema)` to create a new message.
 */
export const CarrierServiceDeleteMutationResponseSchema: GenMessage<CarrierServiceDeleteMutationResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 8);

/**
 * @generated from message shopify.v1.CarrierServiceDeletePayload
 */
export type CarrierServiceDeletePayload = Message<'shopify.v1.CarrierServiceDeletePayload'> & {
    /**
     * @generated from field: string deleted_id = 1;
     */
    deletedId: string;

    /**
     * @generated from field: repeated shopify.v1.UserError user_errors = 2;
     */
    userErrors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceDeletePayload.
 * Use `create(CarrierServiceDeletePayloadSchema)` to create a new message.
 */
export const CarrierServiceDeletePayloadSchema: GenMessage<CarrierServiceDeletePayload> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 9);

/**
 * @generated from message shopify.v1.CarrierServiceUpdateRequest
 */
export type CarrierServiceUpdateRequest = Message<'shopify.v1.CarrierServiceUpdateRequest'> & {
    /**
     * @generated from field: shopify.v1.CarrierService input = 1;
     */
    input?: CarrierService | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceUpdateRequest.
 * Use `create(CarrierServiceUpdateRequestSchema)` to create a new message.
 */
export const CarrierServiceUpdateRequestSchema: GenMessage<CarrierServiceUpdateRequest> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 10);

/**
 * @generated from message shopify.v1.CarrierServiceUpdateResponse
 */
export type CarrierServiceUpdateResponse = Message<'shopify.v1.CarrierServiceUpdateResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceUpdateMutationResponse data = 1;
     */
    data?: CarrierServiceUpdateMutationResponse | undefined;

    /**
     * @generated from field: shopify.v1.Extensions extensions = 2;
     */
    extensions?: Extensions | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError errors = 3;
     */
    errors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceUpdateResponse.
 * Use `create(CarrierServiceUpdateResponseSchema)` to create a new message.
 */
export const CarrierServiceUpdateResponseSchema: GenMessage<CarrierServiceUpdateResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 11);

/**
 * @generated from message shopify.v1.CarrierServiceUpdateMutationResponse
 */
export type CarrierServiceUpdateMutationResponse = Message<'shopify.v1.CarrierServiceUpdateMutationResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceUpdatePayload carrier_service_update = 1;
     */
    carrierServiceUpdate?: CarrierServiceUpdatePayload | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceUpdateMutationResponse.
 * Use `create(CarrierServiceUpdateMutationResponseSchema)` to create a new message.
 */
export const CarrierServiceUpdateMutationResponseSchema: GenMessage<CarrierServiceUpdateMutationResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 12);

/**
 * @generated from message shopify.v1.CarrierServiceUpdatePayload
 */
export type CarrierServiceUpdatePayload = Message<'shopify.v1.CarrierServiceUpdatePayload'> & {
    /**
     * @generated from field: shopify.v1.CarrierService carrier_service = 1;
     */
    carrierService?: CarrierService | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError user_errors = 2;
     */
    userErrors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceUpdatePayload.
 * Use `create(CarrierServiceUpdatePayloadSchema)` to create a new message.
 */
export const CarrierServiceUpdatePayloadSchema: GenMessage<CarrierServiceUpdatePayload> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 13);

/**
 * @generated from message shopify.v1.CarrierServiceCreateRequest
 */
export type CarrierServiceCreateRequest = Message<'shopify.v1.CarrierServiceCreateRequest'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceInput input = 1;
     */
    input?: CarrierServiceInput | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceCreateRequest.
 * Use `create(CarrierServiceCreateRequestSchema)` to create a new message.
 */
export const CarrierServiceCreateRequestSchema: GenMessage<CarrierServiceCreateRequest> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 14);

/**
 * @generated from message shopify.v1.CarrierServiceInput
 */
export type CarrierServiceInput = Message<'shopify.v1.CarrierServiceInput'> & {
    /**
     * @generated from field: string name = 1;
     */
    name: string;

    /**
     * @generated from field: string callback_url = 2;
     */
    callbackUrl: string;

    /**
     * @generated from field: bool active = 3;
     */
    active: boolean;

    /**
     * @generated from field: bool supports_service_discovery = 4;
     */
    supportsServiceDiscovery: boolean;
};

/**
 * Describes the message shopify.v1.CarrierServiceInput.
 * Use `create(CarrierServiceInputSchema)` to create a new message.
 */
export const CarrierServiceInputSchema: GenMessage<CarrierServiceInput> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 15);

/**
 * @generated from message shopify.v1.CarrierServiceCreateResponse
 */
export type CarrierServiceCreateResponse = Message<'shopify.v1.CarrierServiceCreateResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceCreateMutationResponse data = 1;
     */
    data?: CarrierServiceCreateMutationResponse | undefined;

    /**
     * @generated from field: shopify.v1.Extensions extensions = 2;
     */
    extensions?: Extensions | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError errors = 3;
     */
    errors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceCreateResponse.
 * Use `create(CarrierServiceCreateResponseSchema)` to create a new message.
 */
export const CarrierServiceCreateResponseSchema: GenMessage<CarrierServiceCreateResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 16);

/**
 * @generated from message shopify.v1.CarrierServiceCreateMutationResponse
 */
export type CarrierServiceCreateMutationResponse = Message<'shopify.v1.CarrierServiceCreateMutationResponse'> & {
    /**
     * @generated from field: shopify.v1.CarrierServiceCreatePayload carrier_service_create = 1;
     */
    carrierServiceCreate?: CarrierServiceCreatePayload | undefined;
};

/**
 * Describes the message shopify.v1.CarrierServiceCreateMutationResponse.
 * Use `create(CarrierServiceCreateMutationResponseSchema)` to create a new message.
 */
export const CarrierServiceCreateMutationResponseSchema: GenMessage<CarrierServiceCreateMutationResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 17);

/**
 * @generated from message shopify.v1.CarrierServiceCreatePayload
 */
export type CarrierServiceCreatePayload = Message<'shopify.v1.CarrierServiceCreatePayload'> & {
    /**
     * @generated from field: shopify.v1.CarrierService carrier_service = 1;
     */
    carrierService?: CarrierService | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError user_errors = 2;
     */
    userErrors: UserError[];
};

/**
 * Describes the message shopify.v1.CarrierServiceCreatePayload.
 * Use `create(CarrierServiceCreatePayloadSchema)` to create a new message.
 */
export const CarrierServiceCreatePayloadSchema: GenMessage<CarrierServiceCreatePayload> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_carrier_service, 18);
